'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IdealImage = require('../IdealImage');

var _IdealImage2 = _interopRequireDefault(_IdealImage);

var _icons = require('../icons');

var _icons2 = _interopRequireDefault(_icons);

var _theme = require('../theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IdealImageWithDefaults = function IdealImageWithDefaults(props) {
  return _react2.default.createElement(_IdealImage2.default, props);
};

IdealImageWithDefaults.defaultProps = _extends({}, _IdealImage2.default.defaultProps, {
  icons: _icons2.default,
  theme: _theme2.default

  // eslint-disable-next-line react/forbid-foreign-prop-types
});IdealImageWithDefaults.propTypes = _IdealImage2.default.propTypes;

exports.default = IdealImageWithDefaults;


// WEBPACK FOOTER //
// ./node_modules/react-ideal-image/dist/components/IdealImageWithDefaults/index.js